/**
 * @generated SignedSource<<4213b81eb70cd7a247a95d0a3c153c86>>
 * @relayHash a8906421754b7b134c038d4ef34dd3e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4dfc55069aab56c33ee4d17e73a5e9053affda1ce1c9f09e3a4c7cf606878156

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterManagementSettingsApp_Query$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type HelpCenterManagementSettingsApp_Query$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly detailsTabData: {
        readonly " $fragmentSpreads": FragmentRefs<"DetailsTab_helpCenterManagementSettings">;
      } | null;
      readonly name: {
        readonly default: string;
      } | null;
      readonly updateProjectMappingData: {
        readonly " $fragmentSpreads": FragmentRefs<"UpdateProjectMapping_helpCenter">;
      } | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly cloudUrl: AGG$URL | null;
  } | null> | null;
};
export type HelpCenterManagementSettingsApp_Query = {
  response: HelpCenterManagementSettingsApp_Query$data;
  variables: HelpCenterManagementSettingsApp_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = {
  "args": [
    {
      "items": [
        {
          "kind": "Variable",
          "name": "cloudIds.0",
          "variableName": "cloudId"
        }
      ],
      "kind": "ListValue",
      "name": "cloudIds"
    }
  ],
  "concreteType": "TenantContext",
  "kind": "LinkedField",
  "name": "tenantContexts",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "cloudUrl"
    }
  ]
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "default"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HelpCenterManagementSettingsApp_Query",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "DetailsTab_helpCenterManagementSettings"
                        }
                      ],
                      "type": "HelpCenter"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "detailsTabData"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "UpdateProjectMapping_helpCenter"
                        }
                      ],
                      "type": "HelpCenter"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "updateProjectMappingData"
                  }
                ],
                "type": "HelpCenter"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HelpCenterManagementSettingsApp_Query",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "translations",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "locale"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "value"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "siteDefaultLanguageTag"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "autoLinkingEnabled"
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v6/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4dfc55069aab56c33ee4d17e73a5e9053affda1ce1c9f09e3a4c7cf606878156",
    "metadata": {},
    "name": "HelpCenterManagementSettingsApp_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "87677e2d533fcd00c883a6d2e0107038";

export default node;
